import { apiRequest } from "./service";
import {
    GET_HEALTH_PARAMS,
    GET_BLOOD_SUGAR,
    GET_BLOOD_PRESSURE,
    GET_BODY_TEMPERATURE,
    GET_HEART_RATE,
    GET_RESPIRATORY_RATE,
    GET_OXYGEN,
    GET_DOCTOR_HEALTH_PARAMS,
    GET_DOCTOR_BLOOD_SUGAR,
    GET_DOCTOR_BLOOD_PRESSURE,
    GET_DOCTOR_BODY_TEMPERATURE,
    GET_DOCTOR_HEART_RATE,
    GET_DOCTOR_RESPIRATORY_RATE,
    GET_DOCTOR_OXYGEN,
    GET_ORGANIZATION_HEALTH_PARAMS,
    GET_PATIENT_BLOOD_SUGAR_ORGANIZATION,
    GET_PATIENT_BLOOD_PRESSURE_ORGANIZATION,
    GET_PATIENT_BODY_TEMPERATURE_ORGANIZATION,
    GET_PATIENT_HEART_RATE_ORGANIZATION,
    GET_PATIENT_RESPIRATORY_RATE_ORGANIZATION,
    GET_PATIENT_OXYGEN_ORGANIZATION,
    GET_SUBADMIN_HEALTH_PARAMS,
    GET_PATIENT_BLOOD_SUGAR_SUBADMIN,
    GET_PATIENT_BLOOD_PRESSURE_SUBADMIN,
    GET_PATIENT_BODY_TEMPERATURE_SUBADMIN,
    GET_PATIENT_HEART_RATE_SUBADMIN,
    GET_PATIENT_RESPIRATORY_RATE_SUBADMIN,
    GET_PATIENT_OXYGEN_SUBADMIN,
    getUriWithDurationAndDateFormat,
} from "./apiUrl";

/**
 * Comprehensive AI Analysis (used by PatientDashboard)
 * Calls get-health-params with ai_analysis=true
 */
export const getComprehensiveAIAnalysis = (payload) => {
    const userType = localStorage.getItem("userType");

    let URL =
        userType === "patient"
            ? `${getUriWithDurationAndDateFormat(GET_HEALTH_PARAMS(), payload.duration?.toLowerCase(), payload.date)}`
            : userType === "doctor"
                ? `${GET_DOCTOR_HEALTH_PARAMS}&appointmentId=${payload.appointmentId}&duration=${payload.duration?.toLowerCase()}&date=${payload.date}`
                : userType === "organization"
                    ? `${GET_ORGANIZATION_HEALTH_PARAMS}&patientId=${payload.patientId}&duration=${payload.duration?.toLowerCase()}&date=${payload.date}`
                    : `${GET_SUBADMIN_HEALTH_PARAMS}&patientId=${payload.patientId}&duration=${payload.duration?.toLowerCase()}&date=${payload.date}`;

    URL += `&ai_analysis=true`;

    return apiRequest({
        apiUrl: URL,
        method: "GET",
        token: payload.token,
    });
};

/**
 * Per-parameter AI Analysis (used by HealthParameters)
 * Calls the specific health parameter endpoint with ai_analysis=true
 * 
 * @param {Object} payload
 * @param {string} payload.parameterKey - One of: bloodSugarData, bloodPressureData, spo2sData, bodyTemperatureData, heartRateData, respiratorieData
 * @param {string} payload.token
 * @param {string} payload.duration
 * @param {string} payload.date
 * @param {string} [payload.appointmentId] - For doctor context
 * @param {string} [payload.patientId] - For organization/subadmin context
 */
export const getParameterAIAnalysis = (payload) => {
    const userType = localStorage.getItem("userType");
    const { parameterKey, duration, date, appointmentId, patientId, token } = payload;

    // Map parameter keys to their base URLs per user type
    const urlMap = {
        bloodSugarData: {
            patient: GET_BLOOD_SUGAR,
            doctor: GET_DOCTOR_BLOOD_SUGAR,
            organization: GET_PATIENT_BLOOD_SUGAR_ORGANIZATION,
            subadmin: GET_PATIENT_BLOOD_SUGAR_SUBADMIN,
        },
        bloodPressureData: {
            patient: GET_BLOOD_PRESSURE,
            doctor: GET_DOCTOR_BLOOD_PRESSURE,
            organization: GET_PATIENT_BLOOD_PRESSURE_ORGANIZATION,
            subadmin: GET_PATIENT_BLOOD_PRESSURE_SUBADMIN,
        },
        spo2sData: {
            patient: GET_OXYGEN,
            doctor: GET_DOCTOR_OXYGEN,
            organization: GET_PATIENT_OXYGEN_ORGANIZATION,
            subadmin: GET_PATIENT_OXYGEN_SUBADMIN,
        },
        bodyTemperatureData: {
            patient: GET_BODY_TEMPERATURE,
            doctor: GET_DOCTOR_BODY_TEMPERATURE,
            organization: GET_PATIENT_BODY_TEMPERATURE_ORGANIZATION,
            subadmin: GET_PATIENT_BODY_TEMPERATURE_SUBADMIN,
        },
        heartRateData: {
            patient: GET_HEART_RATE,
            doctor: GET_DOCTOR_HEART_RATE,
            organization: GET_PATIENT_HEART_RATE_ORGANIZATION,
            subadmin: GET_PATIENT_HEART_RATE_SUBADMIN,
        },
        respiratorieData: {
            patient: GET_RESPIRATORY_RATE,
            doctor: GET_DOCTOR_RESPIRATORY_RATE,
            organization: GET_PATIENT_RESPIRATORY_RATE_ORGANIZATION,
            subadmin: GET_PATIENT_RESPIRATORY_RATE_SUBADMIN,
        },
    };

    // Fallback to health-params endpoint if parameter key not in map
    const paramUrls = urlMap[parameterKey];
    const rawBaseURL = paramUrls
        ? paramUrls[userType] || paramUrls.patient
        : (userType === "patient" ? GET_HEALTH_PARAMS :
            userType === "doctor" ? GET_DOCTOR_HEALTH_PARAMS :
                userType === "organization" ? GET_ORGANIZATION_HEALTH_PARAMS :
                    GET_SUBADMIN_HEALTH_PARAMS);

    // Resolve if it's a function (patient-specific URLs are lazy functions)
    const baseURL = typeof rawBaseURL === 'function' ? rawBaseURL() : rawBaseURL;

    let URL;
    if (userType === "patient") {
        URL = `${getUriWithDurationAndDateFormat(baseURL, duration?.toLowerCase(), date)}`;
    } else if (userType === "doctor") {
        URL = `${baseURL}&appointmentId=${appointmentId || ""}&duration=${duration?.toLowerCase()}&date=${date}`;
    } else {
        // organization or subadmin
        URL = `${baseURL}&patientId=${patientId || ""}&duration=${duration?.toLowerCase()}&date=${date}`;
    }

    URL += `&ai_analysis=true`;

    return apiRequest({
        apiUrl: URL,
        method: "GET",
        token,
    });
};
